import React, {Component} from 'react'
import {history} from "../../utils/history";
import '../../style/InfoComp.css'
import '../../style/rtl_css/InfoComp.css'
import '../../style/doctorStyles/ClinicDashboard.css';
import '../../style/doctorStyles/rtl_css/clinicDashboard.css';
import '../../style/doctorStyles/MyAdminDashboard.css';
import '../../style/doctorStyles/rtl_css/myAdminDashboard.css';
import PatientsDashboard from './doctor-tabs/doctorComponents/PatientsDashboard'
import AllPatients from './doctor-tabs/doctorComponents/AllPatients'
import PatientTable from './doctor-tabs/doctorComponents/PatientTable'
import ASAYAupdates from './doctor-tabs/doctorComponents/ASAYAupdates'
import {withTranslation} from "react-i18next";
import { connect } from "react-redux";
import {compose} from "redux";
import {filterPatientsTable, setPatientsData} from "../../redux/actions/Tabs-Actions";
import doctorApi from "../../services/ApiServices/doctorApi";



class DoctorDashboardConComposed extends Component {

    constructor(props) {
        super(props);
        this.state = {
            searchValue:"",
            debounceTimeout : null,
            patientSwitch:false,

        }
    }

    async componentDidMount() {
        // await this.getAllPatients("")
    }


    async getAllPatients(value) {
        clearTimeout(this.state.debounceTimeout);

        this.setState({debounceTimeout:
                 setTimeout(async () => {
                    let patients = await doctorApi.getAllPatients({search: value})
                    if (patients) {
                        await this.props.setPatientsData(patients.data)
                    }else{
                        await this.props.setPatientsData([])
                    }
                }, 300)})
    }

    async searchPatientsTable(val) {
        this.setState({searchValue: val})
        await this.getAllPatients(val)
    }


    async switchPatient() {
        let patients=""
        let {searchValue} = this.props
        if (!this.state.patientSwitch) {
            patients = await doctorApi.getAllMyPatients()
        }else{
            patients = await doctorApi.getAllPatients({search:searchValue})
        }
        if (patients) {
            await this.props.setPatientsData(patients.data)
        }

        this.setState({patientSwitch: !this.state.patientSwitch})
    }

    render() {
        let {data,t} = this.props


        return (
            <div className={'totalBackground '}>
                {/*<Dashboard/>*/}
                <PatientsDashboard
                    switchPatient={()=>this.switchPatient()}
                    patientSwitch={this.state.patientSwitch}/>
                {/*
                    <ClinicalDashboard/>
*/}
                <div className={'adminMargin-patientPage'}>

                    <AllPatients
                        searchPatientsTable={val => this.searchPatientsTable(val)}/>

                    <PatientTable/>

                    {/*
                    <ASAYAupdates/>
*/}

                    <div className={'backBox'}/>


                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setPatientsData: patientsData => dispatch(setPatientsData(patientsData)),

        filterPatientsTable:(filterType,payload) => dispatch(filterPatientsTable(filterType,payload)),
    };
}

const mapStateToProps = state => {
    return {
        patientsData:state.patientsTableDataReducer.patientsData,
    };
};

const DoctorDashboard = compose(
    withTranslation(),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(DoctorDashboardConComposed)

export default DoctorDashboard;
